import ProductNameStep from 'containers/OnboardingPlaybook/DemoRequestSteps/ProductName'
import ValuePropStep from 'containers/OnboardingPlaybook/DemoRequestSteps/ValueProp'
import IndustryStep from 'containers/OnboardingPlaybook/DemoRequestSteps/Industry'

export default Object.freeze([
  {
    route: '/product',
    component: ProductNameStep,
  },
  {
    route: '/value',
    component: ValuePropStep,
  },
  {
    route: '/industry',
    component: IndustryStep,
  }
])



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingDemoRequestPlaybookFlow/routes.js